export default __webpack_public_path__ + "static/media/OverviewSleepyCalendar.2d73098f.svg";